import { RequestOptions } from "@faire/web-api--source/types";

const HEADER_CLIENT_SEND_TIME = "X-CLIENT-SEND-TIME";

/**
 * Interceptor that adds the client send time as a header to outgoing requests.
 * This helps with tracking request timing and delay analysis.
 *
 * @param request - The request to modify
 * @returns The modified request with the client send time header
 */
export const clientSendTimeInterceptor = (
  config: RequestOptions
): RequestOptions => {
  const headers = {
    ...config.headers,
    [HEADER_CLIENT_SEND_TIME]: Date.now().toString(),
  };
  return { ...config, headers };
};
